import type { CountryCodes } from '@onevesthq/ov-enums';
import { BankSelectField } from '@ovComponents/3-pattern/bankSelectField/bankSelect';
import type { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useLocalization } from '../../../../../../hooks/useLocalization';
import { showsRequiredFieldError } from '../depositFieldErrors';

type InstitutionOption = {
  required?: FieldRequiredType;
  label?: unknown;
};

export type DepositExternalTransferInstitutionProp = {
  institution?: TransferContextData['institution'];
  option?: InstitutionOption;
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  addInstitutionManually: boolean;
  usOriginOfAccount?: CountryCodes;
};

export const DepositExternalTransferInstitution = ({
  institution,
  option,
  focused,
  onFocus,
  onChange,
  addInstitutionManually,
  usOriginOfAccount,
}: DepositExternalTransferInstitutionProp) => {
  const { translateBackendString } = useLocalization();

  return (
    <BankSelectField
      fullWidth
      sx={{ mb: 2 }}
      label={translateBackendString(option?.label)}
      setInstitution={(e: any) => onChange({ institution: e })}
      institution={institution}
      onBlur={() => onFocus('institution')}
      error={showsRequiredFieldError({
        missing: !institution || Object.keys(institution).length === 0,
        field: 'institution',
        focused,
        requirement: option?.required,
      })}
      addInstitutionManually={addInstitutionManually}
      originOfAccount={usOriginOfAccount}
    />
  );
};
